export const images = [
  "abt-img-one.webp",
  "abt-img-two.webp",
  "abt-img-three.webp",
  "abt-img-four.webp",
  "abt-img-five.webp",
];

export const imagesTwo = [
  "abt-img-six.webp",
  "abt-img-seven.webp",
  "abt-img-eight.webp",
  "abt-img-nine.webp",
  "abt-img-ten.webp",
];

export const benefitData = [
  {
    img: require("../../../image/cryptolistingnew/ben-img-one.webp"),
    title: "Enhanced Visibility",
    desc: "Achieve broader exposure by being listed on popular cryptocurrency tracking platforms, driving potential investors and users to your project.",
  },
  {
    img: require("../../../image/cryptolistingnew/ben-img-two.webp"),
    title: "Credibility Boost",
    desc: "Crypto listing adds a layer of authenticity to your project, enhancing confidence in the minds of potential investors and users.",
  },
  {
    img: require("../../../image/cryptolistingnew/ben-img-three.webp"),
    title: "Market Access",
    desc: "Improve liquidity by gaining access to a wider audience of traders and investors who frequent major cryptocurrency platforms.",
  },
  {
    img: require("../../../image/cryptolistingnew/ben-img-four.webp"),
    title: "Price Discovery",
    desc: "Listing on platforms like CoinMarketCap allows users to easily discover your token's current value and market performance.",
  },
  {
    img: require("../../../image/cryptolistingnew/ben-img-five.webp"),
    title: "Community Growth",
    desc: "A listed token attracts attention, enabling community growth and engagement, essential for the long-term success of any project.",
  },
  {
    img: require("../../../image/cryptolistingnew/ben-img-six.webp"),
    title: "Competitive Edge",
    desc: "Stand out among competitors by showcasing your project on reputable cryptocurrency tracking websites, reinforcing your project's legitimacy.",
  },
];

export const experienceData = [
  {
    img: require("../../../image/cryptolistingnew/exp-img-one.webp"),
    value: "200+",
    label: "Project Completed",
  },
  {
    img: require("../../../image/cryptolistingnew/exp-img-two.webp"),
    value: "50+",
    label: "On going projects",
  },
  {
    img: require("../../../image/cryptolistingnew/exp-img-three.webp"),
    value: "170+",
    label: "Satisfied clients",
  },
  {
    img: require("../../../image/cryptolistingnew/exp-img-four.webp"),
    value: "100+",
    label: "Team Members",
  },
  {
    img: require("../../../image/cryptolistingnew/exp-img-five.webp"),
    value: "8+",
    label: "Countries Serverd",
  },
];
